import { DataRoomAccessStatus, DataRoomStatus } from './data-room.enums';

export type DataRoomAccessAxes = {
  accessStatus: DataRoomAccessStatus;
  roomStatus: DataRoomStatus;
};

/**
 * Access lives on two axes: the room's status and the person's own. They are combined at read
 * time and never folded into one stored value.
 *
 * That is the whole of the Inactive behaviour. Turning a room Inactive writes nothing to any
 * access row, so every individual Active / Pending / Revoked survives untouched and reactivation
 * restores exactly what was there — there is no prior state to remember, and therefore none to
 * lose. Writing "revoked" across the list on deactivation would make reactivation a guess.
 */
export const canOpenDataRoom = ({ accessStatus, roomStatus }: DataRoomAccessAxes): boolean =>
  roomStatus === DataRoomStatus.ACTIVE && accessStatus === DataRoomAccessStatus.ACTIVE;

/**
 * True when the person would be in were the room not paused. The Manage Access banner uses it to
 * say access is paused rather than lost.
 */
export const isDataRoomAccessPaused = ({ accessStatus, roomStatus }: DataRoomAccessAxes): boolean =>
  roomStatus === DataRoomStatus.INACTIVE && accessStatus === DataRoomAccessStatus.ACTIVE;

/**
 * While a room is Inactive its access list is read-only: permission controls and the row actions
 * are disabled for everyone, whatever their individual status.
 */
export const isDataRoomAccessListEditable = (roomStatus: DataRoomStatus): boolean =>
  roomStatus === DataRoomStatus.ACTIVE;
